import type { GraphpadWidgetConfig } from '../graphpad.model';

export const TEST_TRAJECTORY_PRESET: GraphpadWidgetConfig = {
  id: 'test-trajectory',
  type: 'graphpad',
  params: {
    fUp: { type: 'quadratic-vertex', params: { a: 1, h: 3, k: -2 } },
    fDown: { type: 'quadratic-vertex', params: { a: -1, h: -3, k: 2 } },
    trajectoryUp: { type: 'trajectory', params: { of: 'fUp', xStart: 3, xEnd: 5, distance: -0.5 } },
    trajectoryDown: { type: 'trajectory', params: { of: 'fDown', xStart: -3, xEnd: -1, distance: 0.5 } },
  },
  display: {
    canvas: { color: 'neutral-0' },
    coordinateSystem: {
      boundingbox: { xStart: -8, xEnd: 8, yStart: -8, yEnd: 8 },
      grid: { type: 'lines', visible: false },
    },
    elements: {
      trajectoryUp: {
        curve: {
          color: 'green',
          strokeWidth: 3,
          label: { text: 'Concave Up', position: 'top', color: 'green' },
        },
      },
      trajectoryDown: {
        curve: {
          color: 'red',
          strokeWidth: 3,
          label: { text: 'Concave Down', position: 'bottom', color: 'red' },
        },
      },
    },
  },
};
